module.exports = "<p>\n  thankreturn works!\n</p>\n"